import styles from "./ArrowThin.module.scss";

export const LeftArrowThin = () => {
    return (
        <svg
            className={styles.arrow}
            width="18"
            height="14"
            viewBox="0 0 18 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M17 7H1M1 7L7 1M1 7L7 13"
                stroke="#838280"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
